import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {ContentHotel} from '@findhotel/sapi/dist/types/packages/core/src'
import {MAXIMUM_POPULAR_FACILITIES} from 'components/Accommodation/PopularFacilities/constants'
import {scrollToSection} from 'components/ScrollSpy'
import {useAccommodation} from 'hooks/useAccommodation'
import {AccommodationPageNavSections} from 'modules/accommodation/types'
import {getHotelFacilitiesVisibility} from 'modules/overlay/selectors'
import {hideOverlay} from 'modules/overlay/slice'
import {getHotelFacilitiesRanked, TOP_FACILITY_IDS} from 'utils/facilities'

import {Button} from '@vio/atlas/Button'
import {PopUp} from '@vio/atlas/PopUp'
import {cssTheme} from '@vio/atlas/themes'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {FacilitiesPopupContent} from './FacilitiesPopupContent'

const Wrapper = styled.div`
  min-width: 640px;
  max-height: 708px;
  padding-top: ${cssTheme.layout.spacing.s500};
`

interface Props {
  hotel: ContentHotel | undefined
}

export const FacilitiesPopup = ({hotel}: Props) => {
  const dispatch = useDispatch()
  const isFacilitiesPopupOpen = useSelector(getHotelFacilitiesVisibility)

  const onClose = () => {
    dispatch(hideOverlay())
  }

  const {groupedFacilities} = useAccommodation(hotel)
  const topFacilities =
    hotel?.facilities &&
    getHotelFacilitiesRanked(
      hotel.facilities,
      TOP_FACILITY_IDS,
      MAXIMUM_POPULAR_FACILITIES
    )

  const handleBottomCTAClick = () => {
    dispatch(hideOverlay())
    scrollToSection(AccommodationPageNavSections.Rooms, {deferred: true})
  }

  return (
    <PopUp
      prerenderContent
      width={900}
      navBarProps={{
        centerContent: (
          <FormattedMessageWrapper id="amenities" defaultMessage="Amenities" />
        ),
        withDivider: true
      }}
      isOpen={isFacilitiesPopupOpen}
      closeAction={onClose}
      footer={
        <Button
          size="lg"
          fullWidth
          variant="primary"
          onClick={handleBottomCTAClick}
        >
          <FormattedMessageWrapper id="viewRooms" defaultMessage="View rooms" />
        </Button>
      }
    >
      <Wrapper data-id="FacilitiesPopup">
        <FacilitiesPopupContent
          groupedFacilities={groupedFacilities}
          topFacilities={topFacilities}
        />
      </Wrapper>
    </PopUp>
  )
}
